import React, { useState, useEffect, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import { useHistory } from 'react-router-dom';
import VoiceService from '../service';
import ExtensionService from '../service/extensionConfiguration';
import { toast } from 'react-toastify';
import { regex } from './regexs';

import {
  Container,
  Row,
  Card,
  Form,
  Col,
  Input,
  CardHeader,
  CardBody
} from 'reactstrap';
import ReactLoader from 'components/Loader';
import ReactButton from 'components/Buttons/ReactButton';
import { ScreenPrompt } from 'components/ScreenPrompt';

const SectorForm = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const { reset, control, handleSubmit, errors, formState } = useForm();
  const { isDirty } = formState;

  const [isUpdate, setIsUpdate] = useState(false);

  const [extensions, setExtensions] = useState([]);

  const { id } = props.match.params;

  // Get extension to select
  useEffect(() => {
    ExtensionService.getAllSimple()
      .then((response) => {
        setExtensions(response.data.data);
      })
      .catch(() => {
        console.log('Erro ao ler os ramais');
      });
  }, []);

  useEffect(() => {
    if (id) {
      setLoading(true);
      VoiceService.get(id)
        .then((res) => {
          const getVoice = res.data.data;
          const dataUpdateVoice = {
            name: getVoice.name,
            email: getVoice.email,
            extension_id: getVoice.extension_id
          };
          reset(dataUpdateVoice);
          setIsUpdate(true);
          setLoading(false);
        })
        .catch(() => {
          toast.error('Erro ao tentar carregar voiceMail', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    }
  }, [id, reset]);

  const onSubmit = useCallback(
    async (data) => {
      try {
        setLoading(true);
        isUpdate
          ? await VoiceService.update(id, data)
          : await VoiceService.create(data);
        history.push('/admin/voicemail');

        if (isUpdate) {
          // setLoading(false);

          toast.info('VoiceMail foi atualizada com sucesso!');
        } else {
          //setLoading(false);
          toast.success('Voicemail foi cadastrada com sucesso!');
        }
      } catch (err) {
        toast.error(err.response.data.message, {
          autoClose: 3000,
          closeOnClick: true
        });
        history.push('/admin/voicemail');
      }
    },
    [history, isUpdate, id]
  );

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const cancelAction = () => {
    history.push('/admin/voicemail');
  };

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/voicemail"
        buttonTitle="Voltar para a pagina de voicemail"
      />
      <ScreenPrompt
        when={isDirty && !formState.isSubmitting}
        message={`Está certo de que deseja sair? Terá que preencher os dados novamente quando retornar`}
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Voicemail</h3>
                </CardHeader>
                <CardBody>
                  {loading ? (
                    <Row className="justify-content-md-center">
                      <ReactLoader />
                    </Row>
                  ) : (
                    <Form
                      className="needs-validation"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <Row>
                        <Col md="6">
                          <label className="form-control-label">Nome*</label>

                          <Controller
                            as={Input}
                            control={control}
                            name="name"
                            rules={{
                              required: 'Nome é um campo obrigatório',
                              pattern: {
                                // value: regex,
                                // message:
                                //   'Nome não pode possuir espaços ou caracteres especiais'
                              }
                            }}
                            defaultValue=""
                          />
                          <ErrorMessage
                            errors={errors}
                            name="name"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                        <Col md="6">
                          <label className="form-control-label">Email*</label>

                          <Controller
                            as={Input}
                            control={control}
                            name="email"
                            rules={{
                              required: 'Email é um campo obrigatório',
                              pattern: {
                                value: regex,
                                message: 'Formato de email inválido'
                              }
                            }}
                            defaultValue=""
                          />
                          <ErrorMessage
                            errors={errors}
                            name="email"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>

                        <Col md={{ size: 6 }}>
                          <label className="form-control-label">Senha*</label>
                          <Controller
                            as={Input}
                            type="password"
                            control={control}
                            name="password"
                            defaultValue=""
                            rules={{
                              required: 'Senha é um campo obrigatório'
                            }}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="password"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                        <Col md={{ size: 6 }}>
                          <label className="form-control-label">Ramal*</label>
                          <Controller
                            as={
                              <Input type="select">
                                <option value="">Selecione</option>
                                {extensions.map((extension, index) => (
                                  <option
                                    key={index}
                                    value={extension.extension_number}
                                  >
                                    {extension.extension_number}
                                  </option>
                                ))}
                              </Input>
                            }
                            control={control}
                            name="extension_id"
                            rules={{
                              required: 'Ramal é um campo obrigatório'
                            }}
                            defaultValue=""
                          />
                          <ErrorMessage
                            errors={errors}
                            name="extension_id"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                      </Row>
                      <hr />
                      <ReactButton btnColor="confirmation" type="submit">
                        Salvar
                      </ReactButton>

                      <ReactButton
                        btnColor="cancelation"
                        onClick={() => cancelAction()}
                      >
                        Cancelar
                      </ReactButton>
                    </Form>
                  )}
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default SectorForm;
